import { IFacility } from './../../models/facility';
import { ISearchState, FacilityState, ISearchFacilityGroup, RoomFacilityState, ExtraFacilityState } from './../../models/search';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface SearchState extends EntityState<ISearchState> {
}

export const searchAdapter: EntityAdapter<ISearchState> = createEntityAdapter<ISearchState>({
// selectId: model => model.id,
});

export const facilityAdapter: EntityAdapter<ISearchFacilityGroup> = createEntityAdapter<ISearchFacilityGroup>({});

export const initialFacilityState: FacilityState = facilityAdapter.getInitialState();
export const initialRoomFacilityState: RoomFacilityState = facilityAdapter.getInitialState();
export const initialExtraFacilityState: ExtraFacilityState = facilityAdapter.getInitialState();

export const initialSearchState: SearchState = searchAdapter.getInitialState();

export const initialState = {
  facilities: facilityAdapter
};


